import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { BaseProps } from '../common/props';

type Props = BaseProps & {
  disableScroll?: boolean;
  divRef?: React.Ref<HTMLDivElement>;
};

export const DialogBody: React.FC<Props> = ({
  className,
  style,
  disableScroll,
  divRef,
  children,
}) => {
  let cls = classNames(className, Classes.DIALOG_BODY, {
    [Classes.DIALOG_BODY_DISABLE_SCROLL]: disableScroll,
  });

  return (
    <div style={style} className={cls} ref={divRef}>
      {children}
    </div>
  );
};
